export default __webpack_public_path__ + "28ef5af9fdce283513a29276e167c4dc.png";